const ALTCHA_TOKEN_KEY = 'hb_v3_altcha_token'

const DEFAULT_ALTCHA_LANGUAGE = 'en'

const ALTCHA_COPY = {
  en: {
    title: 'Security verification',
    desc: 'Please complete verification to continue.',
    languageLabel: 'Language',
    expired: 'Verification expired. Please try again.',
    invalid: 'Invalid verification data. Please try again.',
    failed: 'Verification failed. Please try again.'
  },
  'zh-CN': {
    title: '安全验证',
    desc: '请完成验证后继续访问',
    languageLabel: '语言',
    expired: '验证已过期，请重试',
    invalid: '验证数据无效，请重试',
    failed: '验证失败，请重试'
  },
  'zh-TW': {
    title: '安全驗證',
    desc: '請完成驗證後繼續訪問',
    languageLabel: '語言',
    expired: '驗證已過期，請重試',
    invalid: '驗證資料無效，請重試',
    failed: '驗證失敗，請重試'
  }
}

const ALTCHA_LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'kk', label: 'Русский' },
  { value: 'es', label: 'Español' },
  { value: 'fr', label: 'Français' },
  { value: 'de', label: 'Deutsch' },
  { value: 'nl', label: 'Nederlands' },
  { value: 'hu', label: 'Magyar' },
  { value: 'fi', label: 'Suomi' },
  { value: 'no', label: 'Norsk' },
  { value: 'it', label: 'Italiano' },
  { value: 'pt', label: 'Português' },
  { value: 'ru', label: 'Pусский' },
  { value: 'tr', label: 'Türkçe' },
  { value: 'ko', label: '한국어' },
  { value: 'ja', label: '日本語' },
  { value: 'vi', label: 'Tiếng Việt' },
  { value: 'id', label: 'Bahasa Indonesia' },
  { value: 'th', label: 'ภาษาไทย' },
  { value: 'ar', label: 'العربية' },
  { value: 'he', label: 'עברית' },
  { value: 'hi', label: 'हिन्दी' },
  { value: 'pl', label: 'Polski' },
  { value: 'sk', label: 'Slovenský' },
  { value: 'cs', label: 'Čeština' },
  { value: 'zh-CN', label: '简体中文' },
  { value: 'zh-TW', label: '繁体中文' }
]

const ALTCHA_LANGUAGE_MAP = {
  'zh-CN': 'zh-cn',
  'zh-TW': 'zh-tw',
  es: 'es-es',
  fr: 'fr-fr',
  pt: 'pt-pt'
}

const ALTCHA_CONFIGURATION = JSON.stringify({
  hideFooter: true,
  hideLogo: true
})

function getStorage(storage) {
  if (storage) return storage
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage
  }
  return null
}

function getAltchaToken(storage) {
  const targetStorage = getStorage(storage)
  return targetStorage ? targetStorage.getItem(ALTCHA_TOKEN_KEY) || '' : ''
}

function setAltchaToken(token, storage) {
  const targetStorage = getStorage(storage)
  if (targetStorage && token) {
    targetStorage.setItem(ALTCHA_TOKEN_KEY, token)
  }
}

function clearAltchaToken(storage) {
  const targetStorage = getStorage(storage)
  if (targetStorage) {
    targetStorage.removeItem(ALTCHA_TOKEN_KEY)
  }
}

function normalizeAltchaLocale(locale) {
  const value = locale || DEFAULT_ALTCHA_LANGUAGE
  return ALTCHA_LANGUAGE_OPTIONS.some(item => item.value === value) ? value : DEFAULT_ALTCHA_LANGUAGE
}

function getCurrentLocale(storage) {
  const targetStorage = getStorage(storage)
  return normalizeAltchaLocale(targetStorage ? targetStorage.getItem('locale') : DEFAULT_ALTCHA_LANGUAGE)
}

function getAltchaLanguage(storage) {
  const locale = getCurrentLocale(storage)
  return ALTCHA_LANGUAGE_MAP[locale] || locale || DEFAULT_ALTCHA_LANGUAGE
}

function getAltchaCopy(storage) {
  const locale = getCurrentLocale(storage)
  return ALTCHA_COPY[locale] || ALTCHA_COPY[locale.substring(0, 2)] || ALTCHA_COPY.en
}

function getAltchaConfiguration() {
  return ALTCHA_CONFIGURATION
}

function getAltchaLanguageOptions() {
  return ALTCHA_LANGUAGE_OPTIONS.map(item => ({
    value: item.value,
    label: item.label
  }))
}

function getAltchaLocaleName(locale) {
  const normalized = normalizeAltchaLocale(locale)
  const option = ALTCHA_LANGUAGE_OPTIONS.find(item => item.value === normalized)
  return option ? option.label : 'English'
}

function setAltchaLocale(locale, storage) {
  const targetStorage = getStorage(storage)
  const normalized = normalizeAltchaLocale(locale)
  if (targetStorage) {
    targetStorage.setItem('locale', normalized)
    targetStorage.setItem('localeName', getAltchaLocaleName(normalized))
  }
  return normalized
}

function extractAltchaPayload(event, widget) {
  const detail = event && event.detail
  if (typeof detail === 'string') return detail
  if (detail && typeof detail.payload === 'string') return detail.payload
  if (detail && typeof detail.altcha === 'string') return detail.altcha

  if (widget && typeof widget.querySelector === 'function') {
    const input = widget.querySelector('input[name="altcha"]')
    return input && typeof input.value === 'string' ? input.value : ''
  }
  return ''
}

function isAltchaVerificationValid(response) {
  return !!(
    response &&
    response.code === 0 &&
    response.data &&
    response.data.verified === true &&
    response.data.token
  )
}

function requiresAltchaVerification(routeName, token) {
  return routeName !== 'altchaVerify' && !token
}

module.exports = {
  ALTCHA_TOKEN_KEY,
  DEFAULT_ALTCHA_LANGUAGE,
  getAltchaToken,
  setAltchaToken,
  clearAltchaToken,
  extractAltchaPayload,
  getAltchaConfiguration,
  getAltchaCopy,
  getAltchaLanguageOptions,
  getAltchaLanguage,
  getCurrentLocale,
  setAltchaLocale,
  isAltchaVerificationValid,
  requiresAltchaVerification
}
